import { Analytics } from '@analytics';
import { Menu, MenuItem } from '@material-ui/core';
import { MoreHoriz as MoreHorizIcon } from '@material-ui/icons';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import messages from './messages';

const InviteMenuButton = ({ inviteId, revokeInvite, sendInvite, inviteeEmail }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpenDropDown = e => {
    setAnchorEl(e.currentTarget);
  };

  const handleCloseDropDown = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <button
        type="button"
        className="mr-[5px] inline-flex items-center justify-center bg-white hover:bg-slate-50 text-slate-600 border border-solid border-slate-300 rounded-xl px-3 py-1.5 shadow-sm transition-colors cursor-pointer"
        onClick={handleOpenDropDown}>
        <MoreHorizIcon />
      </button>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{ style: { marginTop: '8px', borderRadius: '16px' } }}
        open={Boolean(anchorEl)}
        onClose={handleCloseDropDown}>
        <MenuItem
          onClick={() =>
            sendInvite({ emails: [inviteeEmail], isResend: true, isRecommendationEmail: false })
          }>
          <FormattedMessage {...messages.resendInvite} />
        </MenuItem>
        <MenuItem
          onClick={() => {
            Analytics.track('revoke invite');
            revokeInvite(inviteId);
          }}>
          <FormattedMessage {...messages.deleteInvite} />
        </MenuItem>
      </Menu>
    </div>
  );
};

export default InviteMenuButton;
